import { render, staticRenderFns } from "./taskEdit.vue?vue&type=template&id=02828282&scoped=true"
import script from "./taskEdit.vue?vue&type=script&lang=js"
export * from "./taskEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02828282",
  null
  
)

export default component.exports